import { styled } from '@material-ui/core';
import { Typography } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';

const $gutter = 15;

export const MainContainer = styled('div')(({ theme }) => ({
  background: theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : COLORS.WHITE,
  border: theme.palette.type === 'dark' ? `1px solid ${COLORS.DARK_BORDER}` : `1px solid ${COLORS.LIGHT_BORDER}`,
  borderRadius: 8,
  padding: '25px 30px',
  width: '100%',
  position: 'relative',
  [theme.breakpoints.down('xs')]: {
    padding: 15,
  },
}));

export const Heading = styled(Typography)(({ theme }) => ({
  position: 'relative',
  borderBottom: theme.palette.type === 'dark' ? `1px solid ${COLORS.DARK_BORDER}` : `1px solid ${COLORS.LIGHT_BORDER}`,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.DARK,
  alignItems: 'center',
  paddingBottom: 15,
  margin: '0 0 20px',
  '&::before': {
    content: '""',
    background: '#3e8bff',
    height: '1px',
    position: 'absolute',
    width: 42,
    bottom: '-1px',
  },
}));

export const PlainHeading = styled(Typography)({
  marginBottom: 5,
});

export const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 15,
}));

export const FlexTwoColumn = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: 5,
  marginBottom: -10,
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
  '& > p': {
    width: '50%',

    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
}));

export const MediaList = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 5,

  '& > p': {
    display: 'flex',
    alignItems: 'center',
    '&:before': {
      content: '"○"',
      lineHeight: 1,
      color: '#f7bc02',
      width: 14,
      height: 'auto',
      fontSize: 24,
      margin: '0 10px 2px 0',
    },
  },
}));

export const ImageContainer = styled('div')(({ theme }) => ({
  '& > img': {
    maxHeight: 144,
    minWidth: 50,
    minHeight: 144,
    margin: '0 10px 10px 0',
    borderRadius: 8,
    cursor: 'pointer',
    transition: '0.2s',

    '&:hover': {
      opacity: 0.8,
    },
  },
}));

export const MediaItemsContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 25%)',
  gap: $gutter,
  width: `calc(100% - ${$gutter * 3}px)`,
  marginTop: 15,

  [theme.breakpoints.down(1500)]: {
    gridTemplateColumns: 'repeat(2, 50%)',
    width: `calc(100% - ${$gutter}px)`,
  },

  [theme.breakpoints.down(900)]: {
    gridTemplateColumns: 'unset',
    width: '100%',
  },
}));

export const FilesContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 33.33%)',
  gap: $gutter,
  width: `calc(100% - ${$gutter * 2}px)`,
  marginTop: 15,

  [theme.breakpoints.down(1500)]: {
    gridTemplateColumns: 'repeat(2, 50%)',
    width: `calc(100% - ${$gutter}px)`,
  },

  [theme.breakpoints.down(900)]: {
    gridTemplateColumns: 'unset',
    width: '100%',
  },
}));

export const MediaItem = styled('img')(({ theme }) => ({
  maxHeight: 120,
  borderRadius: 8,
}));

export const FileItem = styled('div')(({ theme }) => ({
  background: theme.palette.type === 'dark' ? '#1f2733' : '#f7f7f7',
  // width: '100%',
  height: 46,
  borderRadius: 8,
  display: 'flex',
  alignItems: 'center',
  padding: '10px 15px',
  cursor: 'pointer',
  overflow: 'hidden',
  // maxWidth: 200,
  '& > p': {
    maxWidth: 200,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },

  '& .MuiSvgIcon-root': {
    fontSize: 20,
    marginRight: 7,

    '& svg path': {
      fill: '#3e8bff',
    },
  },
  '&:hover': {
    backgroundColor: theme.palette.type === 'dark' ? '#1c2530' : '#e4e8f0',
  },
}));

export const FlexContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 20,
  paddingBottom: 10,
  width: 'auto',
  marginTop: 10,

  '& > div:last-child': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
}));

export const VideoItemCont = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  // maxHeight: 71,
  maxWidth: 200,
  minHeight: 71,
  minWidth: 126,
  borderRadius: 8,
  marginBottom: 10,

  '& > div': {
    '& > div:first-child': {
      height: 71,
    },

    '& > div:last-child': {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
  },
  '& .profile-video-item': {
    width: '100%',
    borderRadius: 10,
  },
  position: 'relative',
}));

export const ScrollableContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 20,
  paddingBottom: 10,
  width: 'auto',
  flexDirection: 'column',
  maxHeight: 300,
  overflowY: 'auto',
  paddingRight: 10,
  marginTop: 15,
}));

// New Styled Component

export const TextSwitchColor = styled('p')(({ theme, size, withBreakSpaces }: any) => ({
  fontSize: size || 16,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.DARK,
  whiteSpace: withBreakSpaces ? 'break-spaces' : undefined,
}));

export const TextGreyColor = styled('p')(({ theme, size }: any) => ({
  fontSize: size || 14,
  color: COLORS.MAIN_GRAY,
}));
